/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

module.exports = reInterpolate;



//////////////////
// WEBPACK FOOTER
// ../~/lodash/_reInterpolate.js
// module id = 291
// module chunks = 0